module.exports = __webpack_public_path__ + "img/12_102.1b7b8003.png";